import React from "react";
type propsType = {
  contactType: string;
  contactDetails: string;
  icon: JSX.Element;
};
const ContactInfoCard = ({ contactType, contactDetails, icon }: propsType) => {
  return (
    <div className="bg-white w-full  rounded-lg px-4 sm:px-8 md:px-4 lg:px-8 py-4 shadow">
      <div className="flex items-center space-x-4">
        <div className="h-12 w-12 rounded-full bg-primary-base text-white flex justify-center items-center">
          {icon}
        </div>
        <div className="">
          <h1 className="font-medium text-lg">{contactType}</h1>
          <p className="text-gray-600">{contactDetails}</p>
        </div>
      </div>
    </div>
  );
};

export default ContactInfoCard;
